export class CommonConfig {
    public static deleteMessage = "Are you sure you want to delete";
    public static activateMessage = "Are you sure you want to activate";
    public static deActivateMessage = "Are you sure you want to deactivate";
    public static clearFormData = "Are you sure you want to clear";
}


// WEBPACK FOOTER //
// ./src/app/customerservice/common/common.config.ts